import request from '@/util/request';
import qs from 'qs';

export const getDeviceList = (params, options) =>
request.get('/api/v4ward/monitor/device/getList', Object.assign({}, options, { params }));

export const getDeviceDataList = (params, options) =>
request.get('/api/v4ward/monitor/device/data/getList', Object.assign({}, options, { params }));

